import * as constants from '../constants.js'
import notifications from "../notifications";

export default {
    OnSuccess(description){
        notifications.Success('Anúncio', description);
        console.log('Success: ' + description)
    },

    OnError(description){
        notifications.Error('Anúncio', description);
        console.log('Error: ' + description)
    },
    
    OnUnauthorized(){
        window.location.reload();
    },

    async ReportAd(idAd, url){
        let result = await fetch(`${constants.API_ENDPOINT_VEHICLECATALOG}/report`, {
            method: constants.HTTP_METHOD_POST,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify({
                'IdAdvert' : idAd,
                'Url' : url
            })
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status == 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao reportar o anúncio");
                        return null;
                    }
                    if(resp.status == 429){
                        this.OnError("Detectamos uma quantidade abusiva de pedidos. Aguarde e tente novamente.");
                        return null;
                    }
                } else {
                    if (resp.status == 201) {
                        this.OnSuccess("Reportado com sucesso");
                    }
                }

                return resp.json();
            });

        return result;

    }

}

